<template>
  <div>
      <b-button @click="showModal()" class="d-block justify-content-end" :class="getButtonStyle()" :title="getTooltip()">
        {{getButtonText()}}
      </b-button>
    <AddressVerificationStatusModal
      ref="verificationModal"
      v-if="addressVerificationStatusId != null"
      :statusId="addressVerificationStatusId"
      v-model="isExpanded"
    />
  </div>
</template>

<script>
import { Vue, Prop, Component, Ref } from "vue-property-decorator";
import { SystemModule, OrderModule, CompanyModule } from "@/store/modules";
import { getModule } from "vuex-module-decorators";
import AddressVerificationStatusModal from "../../components/widgets/Modals/AddressVerificationStatusModal.vue";

const orderModule = getModule(OrderModule);

export default {
  name: "AddressVerificationStatus",
  components: {
    AddressVerificationStatusModal
  },
  props: {
    addressVerificationStatusId: {
      default: 1,
      type: Number
    },
    buttonStyle: {
      default: "",
      type: String
    }
  },
  data() {
    return {
      isExpanded: false
    };
  },
  computed: {
    ordersWithMissingShipsWithOrders() {
      return 1;
    },
    verificationId: {
      get: function() {
        return this.addressVerificationStatusId;
      },

      set: function(newId) {
        orderModule.updateAddressVerificationStatusId(newId);
      }
    }
  },
  methods: {
    getTooltip() {
      if (this.verificationId == 4) {
        return "Customer's address change request has been denied";
      }

      if (this.verificationId == 3) {
        return "Customer has requested an address change address using the ECSS portal";
      }

      if (this.verificationId == 2) {
        return "Customer address has been verified.";
      }

      return "Customer address has not been verified.";
    },

    getButtonText() {
      if (this.verificationId == 2)
        return "Unverify Address";

      if (this.verificationId == 3){
        return "Review Address Change Request";
      }

      return "Verify Address";
    },

    getButtonStyle() {
      return "btn-primary bg-primary text-light " + this.buttonStyle;
    },

    showModal() {
      this.$refs.verificationModal.showModal();
    }
  }
};
</script>

<style lang="scss" scoped>

.btn-primary {
  border: none;
}

.dark-red {
  background-color: rgb(138, 0, 0);
}

.verified {
  box-shadow: -1px 0px 3px 3px green;
}

.unverified {
  box-shadow: -1px 0px 3px 3px yellow;
}

.change-requested {
  box-shadow: -1px 0px 3px 3px red;
}

svg {
  margin-top: 4px;
}

.address-verification-container .row {
  overflow-wrap: break-word;
}
.address-verification-container .container:first-child .row {
  display: block;
  text-align: right;
}

.address-verification-container .container:nth-child(2) .row {
  display: flexbox;
  padding: 10px;

  padding-top: 15px;
  padding-bottom: 15px;
}
</style>
